module.exports = __webpack_public_path__ + "img/rotterdam5.db153268.jpg";